// Phase 8 R2 — update canned job header (name/description/category).

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';

interface Vars {
  cannedJobId: string;
  name: string;
  description?: string | null;
  category?: string | null;
}

export function useUpdateCannedJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ cannedJobId, name, description, category }: Vars): Promise<void> => {
      const { error } = await (supabase as any).rpc('update_canned_job', {
        p_canned_job_id: cannedJobId,
        p_name: name,
        p_description: description ?? null,
        p_category: category ?? null,
      });
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['canned-jobs-admin'] });
      qc.invalidateQueries({ queryKey: ['canned-jobs'] });
      toast({ title: 'Canned job saved' });
    },
    onError: (err: any) => {
      toast({
        title: 'Could not save canned job',
        description: err?.message ?? 'Unknown error',
        variant: 'destructive',
      });
    },
  });
}
